import { useState } from 'react';
import { Card, Button, ProgressBar, Badge } from '@getpay93/ui';
import { useMePlan, useRequestUpgrade } from '../../data/hooks';
import { money } from '../../lib/format';

export function Suscripcion() {
  const plan = useMePlan();
  const upgrade = useRequestUpgrade();
  const [sent, setSent] = useState(false);
  const p = plan.data;
  const pilotActive = !!p?.pilotUntil && new Date(p.pilotUntil).getTime() >= Date.now();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 560 }}>
      {pilotActive ? (
        <Card padding={14} style={{ borderColor: 'var(--accent-blue)' }}>
          <strong style={{ color: 'var(--accent-blue)' }}>Piloto activo</strong>
          <div style={{ color: 'var(--text-muted)', fontSize: 14 }}>Tu acceso premium de piloto vence el {p?.pilotUntil}.</div>
        </Card>
      ) : null}

      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <strong style={{ color: 'var(--text-strong)' }}>Plan actual</strong>
          <Badge tone={p?.effectiveTier === 'free' ? 'neutral' : 'paid'}>{p?.effectiveTier ?? '—'}</Badge>
        </div>
        {p ? (
          <div style={{ marginTop: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <span style={{ color: 'var(--text-body)' }}>Cupos usados</span>
              <span style={{ color: 'var(--text-hint)' }}>{p.activeClients} / {p.effectiveFreeLimit}{p.bonusFreeSlots ? ` (+${p.bonusFreeSlots} bonus)` : ''}</span>
            </div>
            <ProgressBar value={p.activeClients} max={p.effectiveFreeLimit} height={6} />
            <div style={{ marginTop: 10, fontSize: 14, color: 'var(--text-muted)' }}>Estimado con Pro: {money(p.monthlyEstimate)}/mes ({money(p.pricePerClient)} por cliente).</div>
          </div>
        ) : null}
      </Card>

      {p?.effectiveTier === 'free' ? (
        <Card>
          <strong style={{ color: 'var(--text-strong)' }}>Mejora a Pro</strong>
          <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>Clientes sin límite, reportes mensuales y export. Te contactamos para activar.</p>
          {sent ? (
            <p style={{ color: 'var(--brand-green)', fontWeight: 600 }}>¡Listo! Recibimos tu solicitud, te contactamos pronto.</p>
          ) : (
            <Button disabled={upgrade.isPending} onClick={() => upgrade.mutate(undefined, { onSuccess: () => setSent(true) })}>{upgrade.isPending ? 'Enviando…' : 'Solicitar upgrade'}</Button>
          )}
        </Card>
      ) : null}
    </div>
  );
}
